import { render, staticRenderFns } from "./sampleList.vue?vue&type=template&id=127c4034&scoped=true&"
import script from "./sampleList.vue?vue&type=script&lang=js&"
export * from "./sampleList.vue?vue&type=script&lang=js&"
import style0 from "./sampleList.vue?vue&type=style&index=0&id=127c4034&prod&scoped=true&lang=css&"
import style1 from "./sampleList.vue?vue&type=style&index=1&id=127c4034&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c4034",
  null
  
)

export default component.exports